export default __webpack_public_path__ + "static/media/j48.c934d2ee.jpg";